<app-view-item [class]="class" *ngIf="readonly" [text]="value ? 'Creditable' : 'Payable'" [borderless]="borderless">
</app-view-item>

<nz-select
  #selector
  *ngIf="!readonly"
  [nzAllowClear]="false"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzBorderless]="borderless"
  (keydown)="handleKeyDown($event)"
  (click)="handleClick($event)"
  class="width-100"
>
    <nz-option [nzValue]="true" [nzLabel]="'Creditable'">
    </nz-option>
    <nz-option [nzValue]="false" [nzLabel]="'Payable'">
    </nz-option>
</nz-select>

